export const BKJ_J360_VERSION: string = '11.4.0';
